import { ReactNode } from 'react';
import getAmoutValue from 'ui/structure/AmountValue/AmountValue';
import { ITransactionField } from 'ui/structure/TransactionCard';
import { objectMap } from 'utils/helpers';
import { ghsFormatter, formatTwoDigitDate, amountFormatter } from 'utils/formatters';

// Can be expanded or splitted to modules
export const transactionDataConfig = {
  transactionId: 'Transaction ID:',
  scheduleId: 'Schedule ID:',
  transactionType: 'Transaction Type:',
  sourceAccount: 'Source Account:',
  destinationAccountName: 'Beneficiary Name:',
  destinationAccountNo: 'Beneficiary Account No:',
  destinationBank: 'Bank Name:',
  bankBranch: 'Bank Branch:',
  transactionNarration: 'Narration:',
  workFlowStatus: 'Transaction Status:',
  createDate: 'Transaction Date:',
  totalAmount: 'Total Amount:',
  transactionAmount: 'Total Amount:',
  transactionCharge: 'Charge:',
  phoneNumber: 'Beneficiary Wallet Number:',
  networkCode: 'Network:',
  lastCardDigits: 'Last Card Digit:',
  destinationCountry: 'Beneficiary Country:',
  currencyCode: 'Currency Code:',
  genericTransType: 'Generic Type:',
  routingNumber: 'Routing No:',
  swiftCode: 'Swift Code:',
};

export const transactionValuesMapper = (value: string | number, key: string) => {
  switch (key) {
    case 'amount':
    case 'totalAmount':
    case 'transactionAmount':
      return amountFormatter('ghs', false)(String(value));
    case 'charge':
      return getAmoutValue(String(value));
    case 'createDate':
      return formatTwoDigitDate(value);
    case 'transactionCharge':
      return ghsFormatter.format(Number(value));
    default:
      return value;
  }
};

export const getTransactionsArray = (
  data: Record<string, string | number>,
  config: Record<string, string> = transactionDataConfig,
  mapper: (value: string | number, key: string) => ReactNode = transactionValuesMapper,
  sortArray?: string[],
  defaultCurrency = 'GHS',
): ITransactionField[] => {
  const mappedData = objectMap<ReactNode, string | number>(data, mapper, config);
  const transactionsArray: ITransactionField[] = [];
  const loopWithKeys = sortArray || Object.keys(mappedData);

  loopWithKeys.forEach((key) => {
    const value = mappedData[key];
    const currencyCode = data.currencyCode ? data.currencyCode : defaultCurrency;
    if (typeof value === 'undefined') return;
    const amount = data.transactionAmount || data.totalAmount;
    if (key === 'Total Amount:') {
      transactionsArray.push({
        label: key,
        value: amountFormatter(String(currencyCode), false)(String(amount)),
      });
    } else {
      transactionsArray.push({ label: key, value });
    }
  });

  return transactionsArray;
};
